import React, { useState } from "react";
import { Link } from "react-router-dom";
const Logboekenmenu = ({ token, username }) => {
  const [isActive, setIsActive] = useState(false);
  if (username.bedrijf && username.bedrijf.modules.includes("logboeken")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker" ) {
      return (
        <li className="treeview">
          <a className="cursurhand" onClick={() => setIsActive(!isActive)}>
            <i className="fa fa-book" />
            <span>Logboeken</span>
            <span className="pull-right-container">
              <i className="fa fa-angle-left pull-right" />
            </span>
          </a>
          <ul className={isActive ? "treeview-menu menu-open" : "treeview-menu "}>
            <li>
              <Link to="/logboek" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-book" />
                <span>Overzicht</span>
              </Link>
            </li>
            <li>
              <Link to="/logboek/vergelijken" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-book" />
                <span>Parken Vergelijken</span>
              </Link>
            </li>
            <li>
              <Link to="/logboek/website" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-book" />
                <span>Invullen vanuit website</span>
              </Link>
            </li>
            <li>
              <Link to="/logboek/insert" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-book" />
                <span>Handmatig Invullen</span>
              </Link>
            </li>
          </ul>
        </li>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default Logboekenmenu;
